import { createApp } from 'vue'
import router from './router'
import App from './App.vue'

const vue_app = createApp(App);

vue_app.use( router )

window.vue_instance = vue_app.mount('#app');
// Make router accessible everywhere
window.router = router;